<template>
  <div :class="[classType]">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'Text card',
  props: {
    classType: {
      type: String,
      default: 'container-text'
    }
  }
}
</script>
<style>
.container-text {
  padding-left: 16px;
}
</style>
